<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateProduct"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :dialogName="resourceTitle"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      schema="CreateProduct"
      :id="formId"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetProductGeneral
        :product="editor"
      >
      </FieldsetProductGeneral>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpBox
      alignItems="center"
    >
      <ItpFormGroup
        labelColsMd="4"
        name="sync"
      >
        <ItpFormCheckbox
          name="sync"
          :label="'IntegroRent sync'|pgettext('Product')"
          v-model="editor.sync"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
    </ItpBox>
    <ItpButton
      :text="'Save'|pgettext('Button')"
      type="submit"
      :form="forms[formName]"
      :spinning="actions.create.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.create.isRunning"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateProduct extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_item = new ComponentValueCache(this, "item", "Product.create");
  }

  @Prop({
    type: Boolean,
  })
  preventDefaultOnClose!: boolean;

  @Watch('preventDefaultOnClose')
  onPrevent_default_on_close(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("preventDefaultOnClose")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.$fn.schemaDefaults('CreateProduct', { sync: true })
  }

  formName!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  resource!: any;

  async $$load_resource() {
    return new this.$fn.Resource(this.item)
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  container!: any;

  async $$load_container() {
    return {
      self: this.$fn.urlFor('create_product'),
      object: 'list',
      data: []
    }
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['item', 'formName', 'formId', 'resource', 'editor', 'container', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        formName: "meter",
        formId: null,
        resource: null,
        editor: null,
        container: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.$fn.pgettext("Product", "Product")
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Product", "New product"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3964_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3964, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_setData_3970_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_3970, alias=undefined
    return {
      path: "item",
      value: this.editor.getData(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_1040167445267876_closeComponent_3972_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_3972, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_navigate_3974_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_3974, alias=undefined
    return {
      location: {
        name: "app.product",
        params: {
          id: $event.data.response.data.id,
        }
        ,
      }
      ,
    }
  }

  async evh_1040167445267876_created_3973_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_created_3973, alias=undefined
    return !this.preventDefaultOnClose
  }

  async act_1040167445267876_reloadSlickgrid_3976_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_3976, alias=undefined
    return {
      grid: "products",
    }
  }

  async evh_1040167445267876_created_3975_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_created_3975, alias=undefined
    return !this.preventDefaultOnClose
  }

  async act_1040167445267876_rest_3968_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_3968, alias=create
    return {
      method: "save",
      container: this.container,
      resource: this.editor,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3964: actions.CloseModalAction;
    evh_7315092382398562_close_3963: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_3966: actions.CloseModalAction;
    evh_2248226175642056_close_3965: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_setData_3970: actions.SetDataAction;
    evh_1040167445267876_before_3969: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_3972: actions.CloseComponentAction;
    evh_1040167445267876_created_3971: actions.EventHandlerImpl;
    act_1040167445267876_navigate_3974: actions.NavigateAction;
    evh_1040167445267876_created_3973: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_3976: actions.ReloadSlickgridAction;
    evh_1040167445267876_created_3975: actions.EventHandlerImpl;
    act_1040167445267876_rest_3968: actions.RestAction;
    evh_1040167445267876_submit_3967: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_2186679009640457_closeComponent_3978: actions.CloseComponentAction;
    evh_2186679009640457_clickPreventStop_3977: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3964 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3964_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3963 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3964,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3963],
      }
    );
    const act_2248226175642056_closeModal_3966 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3965 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_3966,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3965],
      }
    );
    const act_1040167445267876_setData_3970 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_3970_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_before_3969 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_3970,
        event: "before",
        displayName: "setData",
      }
    );
    const act_1040167445267876_closeComponent_3972 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_3972_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_created_3971 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_3972,
        event: "created",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_navigate_3974 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_3974_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_created_3973 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_3974,
        event: "created",
        when: this.evh_1040167445267876_created_3973_getWhen,
        displayName: "navigate",
      }
    );
    const act_1040167445267876_reloadSlickgrid_3976 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_3976_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_created_3975 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_3976,
        event: "created",
        when: this.evh_1040167445267876_created_3975_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_rest_3968 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_3968_getActionArgs,
        displayName: "create",
        events: [evh_1040167445267876_before_3969, evh_1040167445267876_created_3971, evh_1040167445267876_created_3973, evh_1040167445267876_created_3975],
      }
    );
    const evh_1040167445267876_submit_3967 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_3968,
        event: "submit",
        displayName: "create",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3967],
      }
    );
    const act_2186679009640457_closeComponent_3978 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_3977 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeComponent_3978,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_3977],
      }
    );
    return {
      act_7315092382398562_closeModal_3964,
      evh_7315092382398562_close_3963,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_3966,
      evh_2248226175642056_close_3965,
      evh_2248226175642056_close,
      act_1040167445267876_setData_3970,
      evh_1040167445267876_before_3969,
      act_1040167445267876_closeComponent_3972,
      evh_1040167445267876_created_3971,
      act_1040167445267876_navigate_3974,
      evh_1040167445267876_created_3973,
      act_1040167445267876_reloadSlickgrid_3976,
      evh_1040167445267876_created_3975,
      act_1040167445267876_rest_3968,
      evh_1040167445267876_submit_3967,
      evh_1040167445267876_submit,
      act_2186679009640457_closeComponent_3978,
      evh_2186679009640457_clickPreventStop_3977,
      evh_2186679009640457_clickPreventStop,
      create: act_1040167445267876_rest_3968,
    }
  }
}

Vue.component("CreateProduct", CreateProduct);

</script>